<template>
<nav class="col-2 col-sm-12 navbar-toggleable navbar navbar-light ml-0 pl-0">
  <button class="navbar-toggler navbar-inverse" type="button" data-toggle="collapse" data-target="#mainnavbar" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <a class="navbar-nav" href="#">Menu</a><span class="navbar-toggler-icon"></span>
    </button>
  <div class="right_nav collapse navbar-collapse" id="mainnavbar">
    <ul class="navbar-nav mr-auto mt-2 mt-md-0">
      <li class="nav-item">
        <router-link class="nav-link text-white" to="/mypage">マイページ</router-link><span class="sr-only">(current)</span>
      </li>
      <li class="nav-item">
        <router-link class="nav-link text-white" to="/list">開催申請管理</router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link text-white" to="/profile">プロフィール管理</router-link>
      </li>
      <li class="nav-item">
        <a class="nav-link text-white" href="/lecturer/login" @click.prevent="logout()">ログアウト</a>
      </li>
    </ul>
  </div>
</nav>
</template>

<script>
import auth from 'auth'

export default {
  methods: {
    logout () {
      auth.logout()
      this.$router.push('/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// GlobalNavBarMenu.vue?f4a6b8ee